<template>
  <div
    :class="cn('text-primary flex flex-col gap-8 rounded-lg bg-white p-5', props.class)"
    :aria-labelledby="labelledBy"
  >
    <NuxtImg class="max-h-7 w-fit" draggable="false" :src="getImageUrl(image)" />

    <div class="flex flex-col gap-2">
      <span class="text-xl font-semibold leading-none" :id="labelledBy">{{ title }}</span>

      <span class="text-sm text-black/50">{{ date }}</span>
    </div>

    <UiButton class="mt-auto w-fit" :to="link" variant="link" size="flat">Read more</UiButton>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  class?: ClassValue
  image: string
  title: string
  date: string
  link: string
}>()

const componentId = useId()
const labelledBy = computed(() => `newsroom-card-${componentId}`)
</script>
